import { ChakraFlex, Text } from '@equip.health/ui';
import { useParams } from 'react-router-dom';

import { useGetAssessmentByIdQuery } from '~/store/services/assessments';
import SurveyAccordion from '~/components/maud/survey/SurveyAccordion';
import OverviewLoading from '~/components/common/OverviewLoading';
import { isValidUUID } from '~/lib/utils';
import { ReactNode } from 'react';

interface CenteredMessageProps {
  children: ReactNode;
  color?: string;
}

const CenteredMessage = ({
  children,
  color = 'gray.500',
}: CenteredMessageProps) => (
  <ChakraFlex
    alignItems="center"
    backgroundColor="white"
    justifyContent="center"
    minHeight="100vh"
    width="100%"
  >
    <Text color={color} textAlign="center" variant="h4">
      {children}
    </Text>
  </ChakraFlex>
);

const StandaloneSurveyPage = () => {
  const { uuid } = useParams<{ uuid: string }>();
  const isValidUuid = uuid && isValidUUID(uuid);

  const {
    data: assessmentData,
    isLoading,
    isError,
  } = useGetAssessmentByIdQuery(uuid ?? '', {
    skip: !uuid || !isValidUuid,
  });

  if (!isValidUuid) {
    return (
      <CenteredMessage color="red.500">
        Invalid survey ID format
      </CenteredMessage>
    );
  }

  if (isLoading) {
    return (
      <ChakraFlex alignItems="center" minHeight="100vh">
        <OverviewLoading
          id="standalone-survey-loading"
          marginTop="0"
          size="40px"
        />
      </ChakraFlex>
    );
  }

  if (isError) {
    return (
      <CenteredMessage color="red.500">
        Error loading assessment
      </CenteredMessage>
    );
  }

  if (!assessmentData) {
    return <CenteredMessage>Assessment not found</CenteredMessage>;
  }

  return (
    <SurveyAccordion
      data={assessmentData}
      isExpanded
      isFullScreen
      onDismiss={() => {}}
      setIsExpanded={() => {}}
      setIsFullScreen={() => {}}
    />
  );
};

export default StandaloneSurveyPage;
